import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import InquirySubCategoryMixin from '@/helpers/vue_mixins/v2/inquiry/InquirySubCategoryMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import Uploader from '@/components/v2/Uploader';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import ActionButton from '@/components/action_button/Index.vue';
import bankSlipUploadAndEmail from '@/plugins/graphql/mutations/v2/order-bank-upload-and-email.gql';
import EcommerceOrder from '@/plugins/graphql/queries/v2/order.gql';
import { OrderFullModel } from '@/helpers/entities/models/OrderFullModel';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { required } from 'vuelidate/lib/validators';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let UploadBankDepositForm = class UploadBankDepositForm extends Mixins(InquirySubCategoryMixin, ViewportSizeMixin, RouterParamsAppMixin, CleverTapEventsMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            images: [],
        };
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    get images() {
        const inputImages = this.form.images.map((input) => input.file);
        return inputImages;
    }
    onCancel() {
        if (this.modal) {
            this.$emit('closeModal');
        }
    }
    onSubmit() {
        this.requestOnFlight();
        this.upload()
            .then(() => {
            this.successNotification('Deposit Slip Successfully Uploaded');
            this.resetForm();
            if (this.modal) {
                this.$emit('closeModal', true);
            }
        })
            .catch((err) => {
            this.errorNotification(err.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async upload() {
        try {
            const response = await this.$apollo.mutate({
                mutation: bankSlipUploadAndEmail,
                variables: {
                    input: {
                        orderUuid: this.orderUuid,
                        bankDepositSlips: this.images,
                    },
                },
                refetchQueries: [
                    {
                        query: EcommerceOrder,
                        variables: {
                            orderUuid: this.orderUuid,
                        },
                    },
                ],
            });
            const { order } = response.data.bankSlipUploadAndEmail;
            this.order.bankSlipUrl = order.bankSlipUrl;
        }
        catch (error) {
            console.error('Photo upload failed:', error);
            throw error;
        }
    }
    get checkImageUnshow() {
        if (this.form.images?.length) {
            const imageStates = this.form.images.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            return true;
        }
        return false;
    }
    resetForm() {
        this.form.images = [];
        this.$refs.uploader?.clearFiles();
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], UploadBankDepositForm.prototype, "modal", void 0);
__decorate([
    Prop({ type: String, default: false })
], UploadBankDepositForm.prototype, "orderUuid", void 0);
__decorate([
    Prop({ type: Object, required: true })
], UploadBankDepositForm.prototype, "order", void 0);
__decorate([
    Prop({ type: Object, default: null })
], UploadBankDepositForm.prototype, "formData", void 0);
__decorate([
    Getter('requestOnFlight')
], UploadBankDepositForm.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Mutation('requestOnFlight')
], UploadBankDepositForm.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], UploadBankDepositForm.prototype, "requestDone", void 0);
UploadBankDepositForm = __decorate([
    Component({
        components: {
            PageTitle,
            Uploader,
            BaseImagePlaceholder,
            ActionButton,
        },
        apollo: {
            order: {
                query: EcommerceOrder,
                variables() {
                    return {
                        orderUuid: this.orderUuid,
                    };
                },
                update(data) {
                    return new OrderFullModel(data.ecommerceOrder);
                },
            },
        },
        validations: {
            form: {
                images: { required },
            },
        },
    })
], UploadBankDepositForm);
export default UploadBankDepositForm;
